// Funões de utilidades gerais para ser usado em qualquer lugar

const moment = require("moment");

const DOMPurify = require("dompurify");
import { marked } from "marked";

marked.setOptions({
  sanitize: true,
  xhtml: true,
  breaks: true,
  gfm: true,
});

import { helpers } from "vuelidate/lib/validators";

export const utils = {
  erro: (error) => {
    if (error.response == undefined) {
      return "Não foi possível fazer a solicitação, favor entrar em contato com o suporte.";
    } else if (error.response.data.message.mensagem) {
      return error.response.data.message.mensagem;
    } else if (error.response.data.message) {
      return error.response.data.message;
    } else {
      return error;
    }
  },

  regexCheck(type) {
    if (type == "RSC") {
      return helpers.regex("reg", /^[ a-zA-Zà-úÀ-Ú0-9_!\\.,\n\r:;-]*$/i);
    }
    if (type == "OTN") {
      return helpers.regex("reg", /^[ a-záàâãéèêíïóôõöúçñ0-9_!\\.,\n:;-]*$/i);
    }
    if (type == "URL") {
      return helpers.regex(
        "url",
        /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ\\/\\.,!@?^)(~`´*+=:ªº°+0-9_-]*$/,
      );
    }
    if (type == "restrictSpecialCharactersRegex") {
      return helpers.regex(
        "reg",
        /^[ a-zA-Zà-úÀ-Ú\\/\\.\n\r,!@?^)(~`´*+=:ªº°+0-9_-]*$/,
      );
    }
  },

  formatDataShort(dateTime) {
    const date = new Date(dateTime);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  },

  formatDataLong(dateTime) {
    const date = new Date(dateTime);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hour = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    const sec = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hour}:${min}:${sec}`;
  },

  formatTimeOnly(isoDate) {
    return moment(isoDate).format("HH:mm:ss");
  },

  formatData(dateTime, ln = "br") {
    const now = moment(new Date()); // Data de hoje
    const past = moment(dateTime); // Outra data no passado
    const duration = moment.duration(now.diff(past));

    let time = "";

    if (duration._data.years) {
      time =
        duration._data.years > 1
          ? duration._data.years + (ln == "br" ? " anos" : " years")
          : ln == "br"
          ? "um ano"
          : "a year";
      return time;
    }

    if (duration._data.months) {
      time =
        duration._data.months > 1
          ? duration._data.months + (ln == "br" ? " meses" : " months")
          : ln == "br"
          ? "um mês"
          : "one month";
      return time;
    }

    if (duration._data.days) {
      time =
        duration._data.days > 1
          ? duration._data.days + (ln == "br" ? " dias" : " days")
          : ln == "br"
          ? "um dia"
          : "one day";
      return time;
    }

    if (duration._data.hours) {
      time =
        duration._data.hours > 1
          ? duration._data.hours + (ln == "br" ? " horas" : " hours")
          : ln == "br"
          ? "uma hora"
          : "one hour";
      return time;
    }

    if (duration._data.minutes) {
      time =
        duration._data.minutes > 1
          ? duration._data.minutes + (ln == "br" ? " minutos" : " minutes")
          : ln == "br"
          ? "um minuto"
          : "one minute";
      return time;
    }

    if (duration._data.seconds || duration._data.milliseconds) {
      time =
        duration._data.seconds > 10
          ? ln == "br"
            ? "menos de um minuto"
            : "less than a minute"
          : ln == "br"
          ? "poucos segundos"
          : "few seconds";
      return time;
    }
  },

  utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  },

  b64_to_utf8(str) {
    try {
      return decodeURIComponent(escape(window.atob(str)));
    } catch {
      return atob(str);
    }
  },

  isBase64(str) {
    try {
      return this.utf8_to_b64(this.b64_to_utf8(str)) == str;
    } catch (err) {
      return false;
    }
  },

  convertMarkedOld(text, images = [], company_name, name) {
    text = !text?.translatedText ? text : text?.translatedText;

    if (text) {
      if (this.isBase64(text)) text = this.b64_to_utf8(text);

      var htmlText = text.replaceAll(
        "@nome_do_especialista",
        name || "João Silva",
      );
      htmlText = htmlText.replaceAll(
        "@documento_do_especialista",
        "999.999.999-99",
      );

      // htmlText = htmlText.replace(/^[^\S+\n]+/mg, "")
      // htmlText = htmlText.replace(/(?:\n)/g, "\n\n");

      // const renderer = {
      //     heading(text, level) {
      //       const escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');
      //       return `
      //               <h${level}>
      //                 <a name="${escapedText}" class="anchor" href="#${escapedText}">
      //                   <span class="header-link"></span>
      //                 </a>
      //                 ${text}
      //               </h${level}>`;
      //     }
      //   };
      //   marked.use({ renderer });

      marked.use({
        tokenizer: {
          code() {},
        },
      });

      htmlText = DOMPurify.sanitize(marked.parse(htmlText));

      images.forEach((element) => {
        let name = element.name;

        if (element.originalName) {
          let url = URL.createObjectURL(element);
          element.path = url;
          name = element.originalName;
        }

        if (
          ["jpeg", "png", "jpg"].includes(
            name.split(".")[name.split(".").length - 1],
          )
        ) {
          htmlText = htmlText.replaceAll(
            `[${element.id}]`,
            `<br><a href="${element.path}" class="attachment-file-preview" data-file-name="${name}" rel="noopener noreferrer"><img class="img-report" alt="${name}" src="${element.path}" /><p class="mb-0"><label class="text-danger m-0">${name}</label></p></a> `,
          );
        } else {
          htmlText = htmlText.replaceAll(
            `[${element.id}]`,
            `<br><a href="${element.path}" rel="noopener noreferrer"><p class="mb-0"><label class="text-danger pointer m-0">Link: ${name}</label></p></a> `,
          );
        }
      });

      htmlText = '<base target="_blank">' + htmlText;

      return htmlText;
    }
  },

  convertHtml(text) {
    if (text) {
      var htmlText = text.replace(/&lt;/g, "<");
      htmlText = htmlText.replace(/&quot;/g, "");
      htmlText = htmlText.replace(/<a href/g, '<a  target="_blank" href');

      var listFunction = [
        "alert",
        "abort",
        "afterprint",
        "animationend",
        "animationiteration",
        "animationstart",
        "beforeprint",
        "beforeunload",
        "blur",
        "canplay",
        "canplaythrough",
        "change",
        "click",
        "contextmenu",
        "copy",
        "cut",
        "dblclick",
        "drag",
        "dragend",
        "dragenter",
        "dragleave",
        "dragover",
        "dragstart",
        "drop",
        "durationchange",
        "ended",
        "error",
        "focus",
        "focusin",
        "focusout",
        "fullscreenchange",
        "fullscreenerror",
        "hashchange",
        "input",
        "invalid",
        "keydown",
        "keypress",
        "keyup",
        "load",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "message",
        "mousedown",
        "mouseenter",
        "mouseleave",
        "mousemove",
        "mouseover",
        "mouseout",
        "mouseup",
        "mousewheel",
        "offline",
        "online",
        "open",
        "pagehide",
        "pageshow",
        "paste",
        "pause",
        "play",
        "playing",
        "popstate",
        "progress",
        "ratechange",
        "resize",
        "reset",
        "scroll",
        "seeked",
        "seeking",
        "select",
        "show",
        "submit",
        "suspend",
        "timeupdate",
        "toggle",
        "touchcancel",
        "touchend",
        "touchmove",
        "touchstart",
        "transitionend",
        "unload",
        "volumechange",
        "waiting",
        "wheel",
        "altKey",
        "animationName",
        "bubbles",
        "button",
        "buttons",
        "cancelable",
        "charCode",
        "changeTouches",
        "clientX",
        "clientY",
        "clipboardData",
        "composed",
        "createEvent",
        "ctrlKey",
        "currentTarget",
        "dataTransfer",
        "defaultPrevented",
        "deltaX",
        "deltaY",
        "deltaZ",
        "deltaMode",
        "detail",
        "elapsedTime",
        "elapsedTime",
        "eventPhase",
        "getTargetRanges",
        "getModifierState",
        "inputType",
        "isComposing",
        "isTrusted",
        "keyCode",
        "location",
        "lengthComputable",
        "loaded",
        "metaKey",
        "MovementX",
        "MovementY",
        "newValue",
        "newURL",
        "offsetX",
        "offsetY",
        "oldValue",
        "oldURL",
        "onemptied",
        "pageX",
        "pageY",
        "persisted",
        "preventDefault",
        "propertyName",
        "pseudoElement",
        "region",
        "relatedTarget",
        "repeat",
        "screenX",
        "screenY",
        "shiftKey",
        "shiftKey",
        "state",
        "stopImmediatePropagation",
        "stopPropagation",
      ];

      listFunction.forEach((item) => {
        htmlText = htmlText.replace(new RegExp(item, "gim"), `${item}_`);
      });
      htmlText = htmlText.replace(new RegExp("iframe", "gim"), `i f r a m e`);

      return htmlText;
    }
  },

  convertMoney(money = 0) {
    money = parseFloat(money);
    return money.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  },

  convertDollar(money = 0) {
    money = parseFloat(money);
    return money
      .toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        currencyDisplay: "symbol",
        minimumFractionDigits: 2,
      })
      .replace(/^(-?)(\D+)/, "$1US$ ");
  },

  uploadVerify(file) {
    const name = file.name;
    const lastDot = name.lastIndexOf(".");
    const ext = name.substring(lastDot + 1);

    if (file.size > 100000000) {
      return "Tamanho máximo do arquivo é de 100MB";
    }
    if (
      file.type.split("/")[0] != "video" &&
      file.type.split("/")[0] != "image" &&
      file.type.split("/")[0] != "text" &&
      !["rar", "zip", "7z"].includes(ext)
    ) {
      return `Arquivo do tipo "${file.type || ext}" não pode ser enviado!`;
    }
    if (
      file.type.split("/")[0] == "text" &&
      !["plain"].includes(file.type.split("/")[1])
    ) {
      return `Aquivos do tipo "${file.type}" não podem ser enviadas, utilize .jpg .jpeg .png .txt .rar .zip .7z!`;
    }
    if (
      file.type.split("/")[0] == "image" &&
      !["jpeg", "png", "jpg"].includes(file.type.split("/")[1]) &&
      !file.type.split("/")[1].match(/svg/)
    ) {
      return `Aquivos do tipo "${file.type}" não podem ser enviadas, utilize .jpg .jpeg .png .txt .rar .zip .7z!`;
    }
  },
  uploadVerifyXML(file) {
    const name = file.name;
    const lastDot = name.lastIndexOf(".");
    const ext = name.substring(lastDot + 1).toLowerCase();

    // Verifica o tamanho do arquivo
    if (file.size > 100000000) {
      return "Tamanho máximo do arquivo é de 100MB";
    }

    // Verifica o tipo do arquivo
    if (
      ext !== "xml" ||
      (file.type !== "text/xml" && file.type !== "application/xml")
    ) {
      return `Apenas arquivos do tipo XML são permitidos!`;
    }
  },
  descriptionMustBeCustomized(description) {
    return (
      description.split(" ").join("") !==
        `
  ##### 1. Summary
  (add vulnerability summary)

  ##### 2. Description
  (add more details about this vulnerability)
  1. [add step]
  
  ##### 3. Steps for analysis
  (Add details of how we can predict the problem)
  1. [add step]
  2. [add step]
  3. [add step]
  
  ##### 4. Support material/references
  (e.g. screenshots, logs, etc.)
  1. List any additional material
  `
          .split(" ")
          .join("") &&
      description.split(" ").join("") !==
        `
      ##### 1. Resumo
      (adicionar resumo da vulnerabilidade)
      
      ##### 2. Descrição
      (adicione mais detalhes sobre esta vulnerabilidade)
      1. [adicionar etapa]

      ##### 3. Passos para reproduzir
      (Adicione detalhes de como podemos reproduzir o problema)
      1. [adicionar etapa]
      2. [adicionar etapa]
      3. [adicionar etapa]
      
      ##### 4. Material de apoio / referências
      (por exemplo, capturas de tela, registros, etc.)
      1. Liste qualquer material adicional
      `
          .split(" ")
          .join("")
    );
  },
  updateTitlePage(pageTitle) {
    document.title =
      pageTitle ?? "Bughunt - Plataforma De Segurança E Recompensa Por Bugs";
  },
  capitalizeFirstLetter(string) {
    if (string.length === 0) {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
};
